export const notImplemented = (message: string) => 
() => {
    throw new Error(message);
  };
  